var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.$store.state.isAuthenticated && _vm.showHeader
        ? _c(
            "b-navbar",
            { attrs: { id: "header", variant: "white", type: "light" } },
            [
              _c(
                "b-navbar-brand",
                { attrs: { href: "/" } },
                [
                  _c("CaLogo", {
                    attrs: { title: "Conversation Analytics Tester" }
                  })
                ],
                1
              ),
              _vm.installationId
                ? _c(
                    "b-navbar-nav",
                    { attrs: { align: "center" } },
                    [_c("InstallationPicker")],
                    1
                  )
                : _vm._e(),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function() {
                              return [_vm._v(" User ")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1195991518
                      )
                    },
                    [
                      _c("b-dropdown-item", { on: { click: _vm.logout } }, [
                        _vm._v("Sign Out")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.hasBooted ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }